import { ApiResponse } from "../../../contract/types";
import { apiClient } from "../client";
export interface AssignProductsRequest {
  parentProductIds: number[];
}

// Assign products to tenant
export const assignParentProductsToTenant = async (
  tenantId: number,
  data: AssignProductsRequest
): Promise<ApiResponse<any>> => {
  const response = await apiClient.post(
    `/corporate/v1/tenant-products?tenant_id=${tenantId}`,
    data
  );

  return {
    data: response.data,
  };
};
